import { withForm } from "~/components/form/app-form";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";

import { offerFormOptions } from "../offer-form-options";

export const GuaranteeSection = withForm({
  ...offerFormOptions,
  render: function Render({ form }) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Satisfaction Guarantee</CardTitle>
          <CardDescription>
            If you offer a satisfaction guarantee, describe it here and we'll
            show it on your offer page.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form.AppField name="satisfactionGuaranteeText">
            {(field) => (
              <field.TextareaField
                label="Satisfaction Guarantee Text"
                maxLength={500}
              />
            )}
          </form.AppField>
        </CardContent>
      </Card>
    );
  },
});
